module.exports = __webpack_public_path__ + "img/conteudo-aprimorado-em-8k.dfa2f39d.png";